var _rect, _path, _path2, _circle, _rect2, _rect3, _rect4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarbleThumbnailContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-light",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-dark",
    d: "M1 11V17H47.5C48.6046 17 49.5 16.1046 49.5 15V1H11C5.47715 1 1 5.47715 1 11Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-dark",
    d: "M101 91L101 85L44 85C42.8954 85 42 85.8954 42 87L42 101L91 101C96.5228 101 101 96.5228 101 91Z",
    fill: "#1E1E1E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thumbnail-dark",
    cx: 57.7119,
    cy: 51,
    r: 25.8607,
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.72149
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-dark",
    x: 19.7046,
    y: 56.3804,
    width: 10.3728,
    height: 4.44547,
    rx: 2.22273,
    fill: "#1E1E1E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-dark",
    x: 19.7046,
    y: 41.5591,
    width: 10.3728,
    height: 4.44547,
    rx: 2.22273,
    fill: "#1E1E1E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-dark",
    x: 16,
    y: 48.9712,
    width: 11.8546,
    height: 4.44547,
    rx: 2.22273,
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-light",
    d: "M81.1193 49.8066C81.5513 50.2077 81.5442 50.8936 81.1042 51.2858L66.2853 64.4937C65.4914 65.2013 64.2881 64.3448 64.6967 63.3629L69.3208 52.2523C69.8192 51.0549 69.8327 49.7106 69.3586 48.5034L65.0155 37.4445C64.6267 36.4544 65.8474 35.6224 66.6268 36.3462L81.1193 49.8066Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarbleThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MarbleThumbnailContrast.9c77b90163b0f353ba9aaea3c1e80cec.svg";